var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1693 25.1667L19.0026 19L12.8359 25.1667",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V32.875",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9363 28.8514C33.4399 28.0316 34.6278 26.7345 35.3123 25.1647C35.9969 23.5949 36.1392 21.8418 35.7168 20.1821C35.2943 18.5224 34.3313 17.0507 32.9795 15.9992C31.6277 14.9477 29.9643 14.3762 28.2517 14.3751H26.3092C25.8426 12.5702 24.9728 10.8946 23.7654 9.47415C22.5579 8.05375 21.0442 6.92555 19.3379 6.17439C17.6317 5.42322 15.7774 5.06863 13.9144 5.13727C12.0514 5.20591 10.2282 5.696 8.58186 6.57069C6.93553 7.44537 5.50891 8.6819 4.40925 10.1873C3.3096 11.6927 2.56552 13.4278 2.23297 15.2622C1.90042 17.0965 1.98804 18.9824 2.48925 20.7781C2.99045 22.5737 3.89221 24.2323 5.12671 25.6293",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1693 25.1667L19.0026 19L12.8359 25.1667",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.06e5b89bf6032bf5a59b80db6c8b7a74.svg";
export { ForwardRef as ReactComponent };